import styled from 'styled-components';

export const ViewRoot = styled.div<{ $active: boolean }>`
  flex: 1;
  display: ${({ $active }) => ($active ? 'flex' : 'none')};
  overflow: hidden;
`;
